var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-location"},[_c('select-course-country',{staticClass:"location-selector",attrs:{"id":"select-country","countries-json":_vm.countriesJson}}),_vm._v(" "),_c('select-course-city',{staticClass:"location-selector",attrs:{"cities-json":_vm.citiesJson}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }